import React, {useState} from 'react'
import "./Subtotal.css";
import CurrencyFormat from "react-currency-format";
import { useStateValue } from './StateProvider';
import { getBasketTotal } from "./reducer";
import {useHistory} from "react-router-dom";

function Subtotal() {
    const history = useHistory();
    const[{basket},dispatch]= useStateValue();
    const [checked,setchecked] = useState(false);
    

    const useCheckbox = (event) => {
        setchecked(event.target.checked);
    }
    return (
        <div className="subtotal">
            <CurrencyFormat
            renderText={(value) => (
                <>
                <p>
                    Subtotal ({basket?.length} artículos):
                    <strong>{value}</strong>
                </p>
                <small className="subtotal_gift">
                    <input type="checkbox" onClick = {useCheckbox}/> He revisado mi pedido
                </small>
                </>
            )}
            decimalScale={2}
            value={getBasketTotal(basket)}
            displayType={"text"}
            thousandSeparator={true}
            prefix={"$"}
            />
        
        <button onClick={checked ? e => history.push('/payment'): null}>Proceder al Pago</button>
        </div>
    )
}

export default Subtotal
